/* eslint-disable class-methods-use-this */
import { ApiException, Language } from '@eta/components';
import { ServiceCreator } from '../ClientProxy/ServiceFactory';
import {
    ValidateTaxpayerOtpRequest,
    ValidateTaxpayerOTPResponse,
    UpdateCurrentUserProfileRequest,
    UserProfileAddressDto,
    IGetCurrentUserDetailsQueryResponseDto,
    GetLookupResponse,
} from '../ClientProxy/clientProxy';
import { authService } from '../../Security/Security';


import { GetUserPreferenceResponse, RecipientNotificationPreferenceRequestDto } from '../ClientProxy/NotificationManagementClient';

export class ProfileManagementService {

    public async getTaxpayersConfig(lang: Language): Promise<GetLookupResponse> {
        
        const client = ServiceCreator.getTaxPayerProfileManagementClient();
        const isArLang = lang.langIso4.includes('ar');
            const currLang = isArLang ? 'ar' : 'en';
        const result = await client.config(currLang);
        return result;
    }

    public async getProfile(): Promise<IGetCurrentUserDetailsQueryResponseDto> {
        const client = ServiceCreator.getTaxPayerProfileManagementClient();
        const result = await client.getCurrentUserDetails();

        return result;
    }

    public async updateCurrentProfile(
        profile: IGetCurrentUserDetailsQueryResponseDto
    ): Promise<number | ApiException> {
        let body;
        if (profile.taxpayerRepresentative) {
            body = new UpdateCurrentUserProfileRequest();
            body.preferredLanguage = profile.preferredLanguage;
            body.emailAddress = profile.taxpayerRepresentative.email;
            body.firstNamePrimaryLang =
                profile.taxpayerRepresentative.firstNamePrimaryLang;
            body.firstNameSecondaryLang =
                profile.taxpayerRepresentative.firstNameSecondaryLang;
            body.lastNamePrimaryLang =
                profile.taxpayerRepresentative.lastNamePrimaryLang;
            body.lastNameSecondaryLang =
                profile.taxpayerRepresentative.lastNameSecondaryLang;
            body.mobileNumber = profile.taxpayerRepresentative.mobileNo;
            body.showGuidanceOnStart =
                profile.taxpayerRepresentative.showGuidanceOnStart;
            body.address = new UserProfileAddressDto();
            body.address.streetName =
                profile.taxpayerRepresentative.address?.streetName;
            body.address.streetName2 =
                profile.taxpayerRepresentative.address?.streetName2;
            body.address.additionalInformation =
                profile.taxpayerRepresentative.address?.additionalInformation;
            body.address.postalCode =
                profile.taxpayerRepresentative.address?.postalCode;
            body.address.buildingNo =
                profile.taxpayerRepresentative.address?.buildingNo;
            body.address.flatNo =
                profile.taxpayerRepresentative.address?.flatNo;
            body.address.floorNo =
                profile.taxpayerRepresentative.address?.floorNo;
            body.address.countryCode =
                profile.taxpayerRepresentative.address?.countryCode;
            body.address.countryID =
                profile.taxpayerRepresentative.address?.countryId;
            if (profile.taxpayerRepresentative.address?.countryCode === 'EG') {
                body.address.cityID =
                    profile.taxpayerRepresentative.address?.cityId;
                body.address.governorateID =
                    profile.taxpayerRepresentative.address?.governorateId;
            } else {
                body.address.foreignCityName =
                    profile.taxpayerRepresentative.address?.foreignCityName;
                body.address.foreignGovernorateName =
                    profile.taxpayerRepresentative.address?.foreignGovernorateName;
            }
        }

        const client = ServiceCreator.getTaxPayerProfileManagementClient();
        const result = await client.updateCurrentUserContactInfo(body);
        return result;
    }

    public async getCurrentNotifications(): Promise<GetUserPreferenceResponse> {
        const client = ServiceCreator.getNotificationClient();
        const result = await client.getUserNotificationpreferences();

        return result;
    }

    public async updateCurrentNotifications(
        Notification: RecipientNotificationPreferenceRequestDto | undefined
    ): Promise<number> {
        const client = ServiceCreator.getNotificationClient();
        const result = await client.saveRecipientPreferenceMy(Notification);
        return result;
    }

    public async otpVerifyUserService(
        request: ValidateTaxpayerOtpRequest,
        code: string | undefined
    ): Promise<ValidateTaxpayerOTPResponse | ApiException> {
        const UserId = Number(authService.currentUser?.profile?.ProfId);
        const client = ServiceCreator.getTaxPayerProfileManagementClient();
        const result = await client.validateUserOtp(
            UserId ?? null,
            code ?? null,
            request
        );
        return result;
    }

    public async otpVerifyTaxpayerProfleService(
        request: ValidateTaxpayerOtpRequest,
        code: string | undefined
    ): Promise<ValidateTaxpayerOTPResponse | ApiException> {
        const Rin = authService.currentUser?.profile?.TaxRin;
        const client = ServiceCreator.getTaxPayerProfileManagementClient();
        const result = await client.validateTaxpayerOtp(
            Rin ?? null,
            code ?? null,
            request
        );
        
        return result;
    }
}
